import React, { useEffect, useMemo, useState } from "react";
import { Card, Col, Empty, Row, Typography, Select } from "antd";
import { HiOutlineChip } from "react-icons/hi";
import { FaUniversity } from "react-icons/fa";
import { MdOutlineCalendarToday } from "react-icons/md";
import { getSessions } from "../../services/sessionService";

const { Title, Paragraph, Text } = Typography;
const { Option } = Select;

const TechnologyInitiativeTab = ({ institution }) => {
  if (!institution) return null;

  const { technology_initiatives = [], faculties = [] } = institution;

  const [selectedFacultyId, setSelectedFacultyId] = useState("All");
  const [selectedSessionId, setSelectedSessionId] = useState("All");
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    loadSessions();
  }, []);

  const loadSessions = async () => {
    try {
      const { data } = await getSessions();
      setSessions(data.data);
    } catch (error) {
      toast.error("Failed to load sessions");
    }
  };

  const filteredInitiatives = useMemo(() => {
    return technology_initiatives.filter((item) => {
      const matchFaculty =
        selectedFacultyId === "All" || item.faculty?.id === selectedFacultyId;
      const matchSession =
        selectedSessionId === "All" || item.session?.id === selectedSessionId;
      return matchFaculty && matchSession;
    });
  }, [technology_initiatives, selectedFacultyId, selectedSessionId]);

  return (
    <div className="pt-4 pb-6">
      {/* Filter Controls */}
      <div className="flex flex-wrap gap-3 mb-6">
        <Select
          value={selectedFacultyId}
          onChange={setSelectedFacultyId}
          className="min-w-[250px]"
          size="middle"
        >
          <Option value="All">All Faculties</Option>
          {faculties.map((faculty) => (
            <Option key={faculty.id} value={faculty.id}>
              {faculty.name}
            </Option>
          ))}
        </Select>

        <Select
          value={selectedSessionId}
          onChange={setSelectedSessionId}
          className="min-w-[250px]"
          size="middle"
        >
          <Option value="All">All Years</Option>
          {sessions.map((session) => (
            <Option key={session.id} value={session.id}>
              {session.name}
            </Option>
          ))}
        </Select>
      </div>

      {/* Initiative Cards */}
      {filteredInitiatives.length === 0 ? (
        <Empty description="No Projects found." className="my-10" />
      ) : (
        <Row gutter={[24, 24]}>
          {filteredInitiatives.map((initiative) => (
            <Col key={initiative.id} xs={24} sm={12} md={8}>
              <Card className="transition-all border border-gray-200 hover:shadow-sm">
                <div className="space-y-2">
                  <Title level={5} className="!mb-1 text-primary">
                    <HiOutlineChip className="inline-block mr-2 text-lg" />
                    {initiative.name}
                  </Title>

                  {initiative.description && (
                    <Paragraph className="text-gray-700 text-sm leading-relaxed">
                      {initiative.description}
                    </Paragraph>
                  )}

                  {initiative.faculty?.name && (
                    <div className="flex items-center gap-2 text-xs text-gray-600">
                      <FaUniversity className="text-gray-400" />
                      <Text>
                        <strong>Faculty:</strong> {initiative.faculty.name}
                      </Text>
                    </div>
                  )}

                  {initiative.session?.name && (
                    <div className="flex items-center gap-2 text-xs text-gray-600">
                      <MdOutlineCalendarToday className="text-gray-400" />
                      <Text>
                        <strong>Year:</strong> {initiative.session.name}
                      </Text>
                    </div>
                  )}
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default TechnologyInitiativeTab;
